import { ExceptionCorrectionItemDto, ExceptionCorrectionItemModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class ExceptionCorrectionItem extends DomainEntity<ExceptionCorrectionItemModelDto> {
    public createDefault(): this {
        return new ExceptionCorrectionItem({
            exceptionCorrectionItem: ExceptionCorrectionItemDto.AccountNumber,
            correctionValue: '',
        }) as this;
    }

    public get exceptionCorrectionItem() {
        return this.dto.exceptionCorrectionItem;
    }

    public set exceptionCorrectionItem(value: ExceptionCorrectionItemDto) {
        this.dto.exceptionCorrectionItem = value;
    }

    public get correctionValue() {
        return this.dto.correctionValue ?? '';
    }

    public set correctionValue(value: string) {
        this.dto.correctionValue = value;
    }
}
